import { createContext, useContext, type ReactNode } from "react";
import { DEFAULT_TAB_ID } from "./navBarStore";

const NavBarTabContext = createContext<string>(DEFAULT_TAB_ID);

/**
 * Names the tab a subtree belongs to. The router adapter mounts one per tab so a
 * screen inside a hidden keep-alive tab registers under its own tab id, not the
 * active one. A host with one tab (the web) needs no scope.
 */
export function NavBarScope({ tabId, children }: { tabId: string; children: ReactNode }) {
    return <NavBarTabContext.Provider value={tabId}>{children}</NavBarTabContext.Provider>;
}

export function useNavBarTabId(): string {
    return useContext(NavBarTabContext);
}
